import * as React from 'react';

interface ISlideoutHeaderCaptionProps {
  icon: React.ReactNode;
  children: React.ReactNode;
}

const SlideoutHeaderCaption = ({ icon, children }: ISlideoutHeaderCaptionProps) => {
  return (
    <div className="flex items-center gap-2 font-semibold text-white">
      {icon}
      {children}
    </div>
  );
};

export default SlideoutHeaderCaption;
